// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router.js'
import axios from 'axios'
// 引入jQuery、bootstrap
import $ from 'jquery'
import 'bootstrap'
// 引入bootstrap样式
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import "@/styles/global.css"
// 全局注册 $
Vue.prototype.$ = $
Vue.prototype.$axios = axios
Vue.config.productionTip = false
new Vue({
  router,
  render:(h)=>h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js